import { activity } from "./en/activity";
import { auth } from "./en/auth";
import { certificates } from "./en/certificates";
import { common } from "./en/common";
import { errors } from "./en/errors";
import { home } from "./en/home";
import { my } from "./en/my";
import { nav } from "./en/nav";
import { organization } from "./en/organization";
import { people } from "./en/people";
import { platform } from "./en/platform";
import { policies } from "./en/policies";
import { shared } from "./en/shared";
import type { Translation } from "./types";

/** English. Same keys as `es` (enforced by `Translation` and a test). */
export const en: Translation = {
  shared,
  common,
  nav,
  auth,
  home,
  certificates,
  policies,
  people,
  activity,
  organization,
  my,
  platform,
  errors,
};
